<script>
  import {getContext} from 'svelte';
  import {Button} from '@px/button';
  import {PATHS} from '@/const/paths';
  import {fixLink$} from '@/store/lang';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');

  function handleClick() {
    window.location.assign($fixLink$(PATHS.WEB3_SOCIAL_TRADE_EXPLORE_GROUPS.pathname));
  }
</script>

<style>
  .soul-pass-entry {
    padding-bottom: 40px;
  }
  .wrap {
    align-items: end;
    margin: 0 auto;
    border: 1px solid #edeff3;
    max-width: 1200px;
    overflow: hidden;
  }
  .content {
    padding: 42px 24px;
  }
  .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
  .bg-img.h5 {
    display: none;
  }
  .bg-img.pc {
    display: block;
  }
  .btn-inner {
    margin-left: -24px;
    border: 1px solid #fff;
    border-radius: 8px;
    padding: 12px;
    color: #fff;
  }
  @media screen and (max-width: 640px) {
    .bg-img.h5 {
      display: block;
    }
    .bg-img.pc {
      display: none;
    }
    .wrap {
      border: unset;
      border-radius: unset;
      padding: 20px 16px;
      width: auto;
      background: rgba(0, 71, 255, 0.08);
    }
    .content {
      margin: 0;
      padding: 0 35% 0 0;
    }
    .xs\:mb16 {
      margin-bottom: 16px;
    }
    .xs\:lh16 {
      line-height: 16px;
    }
    .lh14 {
      line-height: 14px;
    }
    .xs\:f14 {
      font-size: 14px;
    }
  }
</style>

<div class="soul-pass-entry B1">
  <div class="wrap pr br12">
    <img alt={LG(lang.PhemexTokenActivityTitle)} class="bg-img pc" src={IMAGES.SOULPASS_BG} />
    <img alt={LG(lang.PhemexTokenActivityTitle)} class="bg-img h5" src={IMAGES.SOULPASS_BG_H5} />
    <div class="content pr">
      <div>
        <div class="mb10 xs:dn">
          <span class="lh20 f16 TW xs:f14">{LG(lang.PhemexTokenActivityTitle)}</span>
        </div>
        <div class="mb40 lh36 f24 fw3 cf xs:mb16 xs:lh16 xs:f14">{@html LG(lang.PhemexTokenActivityContent, {Bonus: `<span style="color: #38d102;">${LG(lang.Bonus)}</span>`})}</div>
        <Button class="xs:dn" type="text" size="large" on:click={handleClick}>
          <div class="btn-inner">{LG(lang.PhemexTokenActivityOperate)}</div>
        </Button>
        <div class="dn lh14 f12 T4 xs:db" on:click={handleClick}>
          <span>{LG(lang.PhemexTokenActivityOperate)}</span>
          <i class="iconfont ml8 f12">&#xe60b;</i>
        </div>
      </div>
    </div>
  </div>
</div>
